import React, { useState, useEffect } from "react";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentStep } from "../../../Redux/store/onboardingFormSlice";

const ReviewSubmitCorporate = ({ setCurrentStep }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState("John");
  const [profilePic, setProfilePic] = useState("/avatar.svg");
  const [lastName, setLastName] = useState("Mayer");
  const [email, setEmail] = useState("mayer@gmail.com");
  const [otherActivity, setOtherActivity] = useState("");
  const [mobileNumber, setMobileNumber] = useState("+61 6 7898 7298");
  const [customerType, setCustomerType] = useState("+61 6 7898 7298");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
 
  const [advisorRefNumber, setAdvisorRefNumber] = useState(
    "99834 (Brian	Vaughan)"
  );
  const [typeOfAccount, setTypeOfAccount] = useState(
    "Customer with joint account between a husband and wife with same address"
  );
  const [fullName, setFullName] = useState("John Mayer");
  const [formerNames, setFormerNames] = useState("John Mayer");
  const [dob, setDob] = useState("4/5/1988");
  const [redAddress, setRedAddress] = useState(
    "122NC Cross Road, Main City Melbourne"
  );
  const [ownership, setOwnership] = useState("");
  const [toCurrencyText, setToCurrencyText] = useState("");
  const [source, setSource] = useState("");
  const [investmentAmountText, setInvestmentAmountText] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentAddress, setAgentAddress] = useState("");

  const [applicantCountryText, setApplicantCountryText] = useState("Australia");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [jointAccountID, setJointAccountID] = useState("CM0013189P");
  const [expectedAmount, setExpectedAmount] = useState("$50 - $100 million");
  const [investmentCurrency, setInvestmentCurrency] = useState("AUD");
  const [signatory, setSignatory] = useState("yes");
  const [thirdPartySign, setThirdPartySign] = useState("yes");
  const [jointAccountName, setJointAccountName] = useState("");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [abn, setAbn] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("ACB2231");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessActivity, setBusinessActivity] = useState("smaple text");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [fundSource, setFundSource] = useState("smaple text");
  const [transactionNature, setTransactionNature] = useState("");
  const [caprockFund, setCaprockFund] = useState("smaple text");
  const [image, setImage] = useState("/avatar.svg");
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState("testing 1 2 3");
  const [fileProof, setFileProof] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [accountType, setAccountType] = useState(null);

  const [accountTypeLabel, setAccountTypeLabel] = useState("Individual");
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [advisorName, setAdvisorName] = useState("Brian	Vaughan");
  const [preview, setPreview] = useState("/avatar.svg");
  const [stateId, setStateId] = useState(null);
  const [stateText, setStateText] = useState("");
  const [stockExchangeId, setStockExchangeId] = useState("");
  const [transactionLevel, setTransactionLevel] = useState("");
  const [toCurrency, setToCurrency] = useState(2);
  const [investmentAmount, setInvestmentAmount] = useState(null);
 
  const secondheaders = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];
  const [companyCategory, setCompanyCategory] = useState("");
  const [recommendedBy, setRecommendedBy] = useState("");
  const [DoI, setDoI] = useState("");
  const [foreignRegistered, setForeignRegistered] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [foreignAddress, setForeignAddress] = useState("");
  const [stateName, setStateName] = useState("");
  const [EIN, setEIN] = useState("");
  const [acn, setAcn] = useState("");
  const [stockRegistered, setStockRegistered] = useState("");
  const [arbn, setArbn] = useState("");
  const [companySecretary, setCompanySecretary] = useState("");
  const [companyTypeText, setCompanyTypeText] = useState("");
  const [companyCodeText, setCompanyCodeText] = useState("");

  const [countryCode, setCountryCode] = useState(1);
  const [countryCodeText, setCountryCodeText] = useState("Australia");


  const [registeredAddress, setRegisteredAddress] = useState("");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [stockExchangeText, setStockExchangeText] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");

  const [bankdata, setBankdata] = useState([]);
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState("John");
  const [nonphotoIdText, setNonPhotoIdText] = useState("John");
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState("02/12/2026");
  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("");
  const [photoIdSecondText, setphotoIdSecondText] = useState("");

  const [ticketLink, setTicketLink] = useState("");
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);

  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [fileTicket, setFileTicket] = useState(null);

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [accounts, setAccounts] = useState([]);

  const [selected, setSelected] = useState(null);
  const [customDate, setCustomDate] = useState("");

  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [limitDurationLabel, setLimitDurationLabel] = useState("Per Day");
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [signatoryType, setSignatoryType] = useState(1);
  const [members, setMembers] = useState([]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [layers, setLayers] = useState([]);
  const [shareholders, setShareholders] = useState([]);
  const [layerData, setLayerData] = useState({});
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [abnStatus, setAbnStatus] = useState("");
  const [ifApplicable, setIfApplicable] = useState("no");
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [jurisdiction, setJurisdiction] = useState("");
  const [stockexchangeLocation, setStockexchangeLocation] = useState("");
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [hasLicense, setHasLicense] = useState("no");
  const [licenseNumber, setLicenseNumber] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const setReviewFields = () => {

    //  setMembers(formData.members);
    // setLayers(formData.shareholderLayers);
    // setShareholders(formData.shareholders);
    // setLayerData(formData.layerData);
    // setBankdata(formData.bankdata);
    // setAccounts(formData.userAccounts);
    setCustomerType(formData.accountTypeLabel);
    setProfilePic(formData.profilePic);
    setAdvisorRefNumber(formData.advisorRefNumber);
    setRefNumber(formData.refNumber);
    setAdvisorName(formData.advisorName);
    setPreview(formData.preview);
    setFullName(formData.fullName);
    setFormerNames(formData.formerNames);
    setClientNo(formData.clientId);
    setBusinessNature(formData.businessNature);
    setBusinessNatureText(formData.businessNatureText);
    setBusinessActivity(formData.activity);
    setBusinessActivityText(formData.activityText);
    setOtherActivity(formData.otherActivity);
    setDoI(formData.DoI);
    setForeignRegistered(formData.foreignRegistered);
    setCompanyRegistrationNumber(formData.companyRegistrationNumber);
    setForeignAddress(formData.foreignAddress);
    setRegisteredAddress(formData.registeredAddress);
    setPrincipalAddress(formData.principalAddress);
    setStateId(formData.stateId);
    setStateText(formData.stateText);
    setAbn(formData.abn);
    setAcn(formData.acn);
    setStockRegistered(formData.stockRegistered);
    setStockExchangeId(formData.stockExchangeId);
    setStockExchangeText(formData.stockExchangeText);
    setArbn(formData.arbn);
    setCompanySecretary(formData.companySecretary);
    setCompanyWebsite(formData.companyWebsite);
    setToCurrencyText(formData.toCurrencyText);
    setToCurrency(formData.toCurrency);
    setSource(formData.source);
    setInvestmentAmountText(formData.investmentAmountText);
    setInvestmentAmount(formData.investmentAmount);
    setTransactionLevel(formData.transactionLevel);
    setAgentName(formData.agentName);
    setAgentAddress(formData.agentAddress);
    setEIN(formData.EIN);
    setCountryCode(formData.countryCode);
    setCountryCodeText(formData.countryCodeText);
    //Corporate
    setCompanyTypeId(formData.companyTypeId);
    setCompanyTypeText(formData.companyTypeLabel);
    setAccountType(formData.companycategoryId);
    setAccountTypeLabel(formData.companycategoryLabel);
    // Upload Doc
    setFileTicket(formData.fileTicket);
    setTicketLink(formData.ticketLink);
    setFilePublicDocument(formData.filePublicDocument);
    setFileCompanyRegistration(formData.fileCompanyRegistration);
    setFileDisclosure(formData.fileDisclosure);
    setFileExtractDocument(formData.fileExtractDocument);
    setHasLicense(formData.hasLicense);
    setLicenseNumber(formData.licenseNumber);
    setFileLicense(formData.fileLicense);
    setFileForeignRegistration(formData.fileForeignRegistration);
    setJurisdiction(formData.jurisdiction);
    setStockexchangeLocation(formData.stockexchangeLocation);
    setFileFinancialService(formData.fileFinancialService);
    setIfApplicable(formData.ifApplicable);
    setDescription(formData.description);
    setFileProof(formData.fileProof);
    setAbn(formData.abn);
    setAbnStatus(formData.abnStatus);
    setFileThirdParty(formData.fileThirdParty);
    setFileActivityEvidence(formData.fileActivityEvidence);
    setFileAdviceStatement(formData.fileAdviceStatement);
    setWebLink(formData.webLink);
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => (newState[l.name] = true)); // true = collapsed
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => (newState[l.name] = false)); // false = expanded
    setCollapsedLayers(newState);
  };
 
  useEffect(() => {
    if (formData) {
      setReviewFields();
      dispatch(clearCurrentStep());
    }
  }, [formData]);
 
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-2">
            <div className="flex items-center border-colour-custom space-x-2 px-4">
              <img
                src="/profile-circle-black.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">
                Open Account Information
              </h1>
            </div>

            <div className="bg-white">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    First Name
                  </label>
                  <span>{firstName}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Last Name
                  </label>
                  <span>{lastName}</span>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="email"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Email
                  </label>
                  <span>{email}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Mobile Number
                  </label>
                  <span>{mobileNumber}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="customerType"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Customer Type
                  </label>
                  <span>{customerType}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">

            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/briefcase.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Corporate Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
 
            </div>

            <div className="bg-white pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Company Logo
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img

                      src={preview}
                      alt={`${fullName}`}
 
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Advisor Ref No
                  </label>

<span>{refNumber}</span>
                  <label
                    htmlFor="companyCategory"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Company Category
                  </label>

                  <span>{accountTypeLabel}</span>

                  <label
                    htmlFor="fullName"
                    className="mb-1 mt-4 text-sm text-labelColour whitespace-normal words-break"
                  >
                    Full Name of the Company (as Registered by the Asic)
                  </label>
                  <span>{fullName}</span>
                  <label
                    htmlFor="formerNames"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    All Other Business Name(s)
                  </label>
                  <span>{formerNames}</span>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  {accountType != 1 && (
                    <>
                      {" "}
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Client ID
                      </label>
                      <span>{clientNo}</span>
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour"
                      >
                        Recommended by
                      </label>
                      <span>{recommendedBy}</span>
                    </>
                  )}
                  <label
                    htmlFor="clientNo"
                    className="mb-1 text-sm mt-4 text-labelColour"
                  >
                    Business Nature
                  </label>
                  <span>{businessNatureText}</span>
                  <label
                    htmlFor="expectedAmount"
                    className="mt-4 mb-1 text-sm text-labelColour"
                  >
                    Business Activity
                  </label>
                  <span>{businessActivityText}</span>
                  {businessActivity == 6 && (
                    <>
                      <label
                        htmlFor="expectedAmount"
                        className="mt-4 mb-1 text-sm text-labelColour"
                      >
                        Other Activity
                      </label>
                      <span>{otherActivity}</span>
                    </>
                  )}
                  <label
                    htmlFor="clientNo"
                    className="mb-1 text-sm mt-4 text-labelColour"
                  >
                    Company's Date of Incorporation
                  </label>
                  <span>{DoI}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  {accountType == 1 && (
                    <>
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Client No
                      </label>
                      <span>{clientNo}</span>
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour"
                      >
                        Recommended by
                      </label>
                      <span>{recommendedBy}</span>
                    </>
                  )}
                  {accountType != 1 && (
                    <>
                      {" "}
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                      >
                        Is the company registered by the relevant foreign
                        registration body?
                      </label>
                      <span>{foreignRegistered}</span>
                      {foreignRegistered === "yes" && (
                        <>
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm mt-4 text-labelColour"
                          >
                            Employer Identification Number (EIN)
                          </label>
                          <span>{EIN}</span>
                        </>
                      )}
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour"
                      >
                        Company registration number
                      </label>
                      <span>{companyRegistrationNumber}</span>
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour whitespace-normal words-break"
                      >
                        The address of the company in its country of formation,
                        incorporation or registration as registered by the
                        relevant foreign registration body
                      </label>

                      <span>{foreignAddress.full}</span>

                    </>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  {(accountType == 1 || accountType == 2) && (
                    <>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Registered by ASIC as
                      </label>
                      <span>{companyTypeText}</span>
                    </>
                  )}
                  {accountType == 3 && (
                    <>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Type Of Company
                      </label>
                      <span>{companyTypeText}</span>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour mt-4"
                      >
                        Company’s Domicile Country
                      </label>

                      <span>{countryCodeText}</span>

                    </>
                  )}
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                  >
                    Address of the Company's Registered Office
                  </label>

                  <span>{registeredAddress.full}</span>

                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                  >
                    Address of the Company's Principal place of business
                  </label>

                  <span>{principalAddress.full}</span>

                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  {accountType == 1 && (
                    <>
                      {" "}
                      <label
                        htmlFor="businessName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        State or Territory in Australia
                      </label>

                      <span>{stateText}</span>

                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        ACN
                      </label>
                      <span>{acn}</span>
                    </>
                  )}
                  {accountType == 3 && (
                    <>
                      {" "}
                      <label
                        htmlFor="businessName"
                        className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                      >
                        Is your company listed under an Australian Comparable
                        Stock Exchange?
                      </label>
                      <span>{stockRegistered}</span>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Relevant Stock Exchange
                      </label>
                      <span>{stockExchangeText}</span>
                    </>
                  )}
                  {accountType != 1 && (
                    <>
                      {" "}
                      <label
                        htmlFor="businessName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ARBN
                      </label>
                      <span>{arbn}</span>
                    </>
                  )}
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour break-words"
                  >
                    The Name of the Company’s Secretary
                  </label>
                  <span>{companySecretary}</span>
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Company Website
                  </label>
                  <span>{companyWebsite}</span>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Default Investment Currency
                  </label>
                  <span>{toCurrencyText}</span>
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                  >
                    Nature and level of the intended transaction behaviour
                  </label>

                  <span>{transactionLevel}</span>

                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="businessName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Source of the funds including its origin
                  </label>
                  <span>{source}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour break-words"
                  >
                    Expected Investment Amount
                  </label>
                  <span>{investmentAmountText}</span>
                </div>
              </div>
              {accountType != 1 && (
                <>
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4 mt-4">
                    <h1 className="text-xl font-medium mb-2">
                      Details of the company's local agent in Australia (if any)
                    </h1>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="agentName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Full Name
                      </label>
                      <span>{agentName}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Address
                      </label>

                      <span>{agentAddress.full}</span>

                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4"></div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Shareholders and directors section */}
          <div className="bg-white mt-4 border rounded-md p-4">
            <div className="border-b">
              {/* Header */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-colour-custom px-4 pb-2 mb-4 gap-2">
                <div className="flex items-center gap-2">
                  <img
                    src="/people.svg"
                    alt="User Avatar"
                    className="h-6 w-6"
                  />
                  <h1 className="text-xl font-medium">
                    Directors:{" "}
                    <span className="text-[#8C8C8C] font-medium">
                      Phinix LLC
                    </span>
                  </h1>
                </div>
                <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
                  <span className="text-sm text-labelColour">
                    Number of directors within your organisation:
                  </span>
                  <span className="text-sm font-medium text-black">
                    <div className="font-semibold">
                      <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1  bg-white shadow-md">
                        {/* Count display */}
                        <span className="text-sm font-medium bg-gray-400 rounded-lg text-white p-2">
                          {members.length.toString().padStart(2, "0")}
                        </span>
                      </div>
                    </div>
                  </span>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(2);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
              </div>
              {/* Directors Table */}
              <div className="overflow-x-auto">
                <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                  <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                    <tr>
                      <th className="p-2 w-[40px]"></th>
                      <th className="p-2">First Name</th>
                      <th className="p-2">Last Name</th>
                      <th className="p-2">Email Address</th>
                      <th className="p-2">Mobile Number</th>
                      <th className="p-2">Managing Member</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members.map((member, idx) => (
                      <tr key={idx} className="border-t bg-white align-top">
                        <td className="p-2 font-medium text-labelColour">
                          {(idx + 1).toString().padStart(2, "0")}.
                        </td>
                        <td className="p-2 font-medium">
                          <span>{member.firstName}</span>
                        </td>
                        <td className="p-2 font-medium">
                          <span>{member.lastName}</span>
                        </td>
                        <td className="p-2 font-medium">
                          <span>{member.email}</span>
                        </td>
                        <td className="p-2 font-medium">
                          <span>{member.firstName}</span>
                        </td>
                        <td className="p-2 flex justify-center items-center">
                          <input
                            type="radio"
                            name="managingMember"
                            value="yes"
                            checked={member.managingMember === "yes"}
                            className="w-4 h-4 confirm-check-disabled border-gray-300 focus:ring-[#005a9c]"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Signatory Section */}
              {members.length > 0 && (
                <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* Signatory Type */}
                  <div className="flex flex-col px-2 pt-4">
                    <label
                      htmlFor="applicantCountry"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Signatory Type
                    </label>
                    <span>{signatoryTypeLabel}</span>
                  </div>

                  {/* Signatories */}
                  <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
                    <label
                      htmlFor="applicantCountry"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Signatory/Signatories
                    </label>
                    <span>{signatoryTypeLabel}</span>
                  </div>

                  {/* File Upload */}
                  {signatoryType === 1 && (
                    <div className="flex flex-col px-2 pt-4">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Board Resolution
                        </label>
                      </div>

                      {fileAttorney && (
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(fileAttorney);
                          }}
                          className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                        >
                          <div className="flex-col flex">
                            <span className="text-black">
                              {fileAttorney.name}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {formData.companyTypeId == 2 && (
                <>
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-lg font-medium mb-2">
                      Transaction Limit
                    </h1>
                  </div>
                  <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Signatory Type */}
                    <div className="flex flex-col px-2 pt-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Duration
                      </label>
                      <span>{limitDurationLabel}</span>
                    </div>
                    <div className="flex flex-col px-2 pt-4 md:border-r md:border-t-0 md:border-l border-gray-300">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Amount in Dollars ($)
                      </label>
                      <span>{minimumInvestment}</span>
                    </div>

                    <div className="flex flex-col px-2 pt-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Transaction Limit Expiry Date{" "}
                      </label>
                      <span>
                        {selected === "custom"
                          ? formatDate(customDate) || "DD/MM/YYYY"
                          : selected === "never"
                          ? "Never Expire"
                          : ""}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
            {formData.companyTypeId == 1 && (
              <div className="bg-white  rounded-md mt-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                  <div className="flex items-center space-x-2">
                    <img
                      src="/people.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Shareholders:
                      <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                        Phinix LLC
                      </span>
                    </h1>
                  </div>
                  <div className="flex space-x-2">
                    <button
                      onClick={handleCollapseAll}
                      className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                    >
                      <img
                        src="/arrow-square-up.svg"
                        alt="Collapse Icon"
                        className="w-4 h-4 flex-shrink-0"
                      />
                      <span className="font-medium">Collapse All</span>
                    </button>
                    <button
                      onClick={handleExpandAll}
                      className="bg-black text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                    >
                      <img
                        src="/arrow-square-down.svg"
                        alt="Collapse Icon"
                        className="w-4 h-4 flex-shrink-0"
                      />
                      <span className="font-medium">Expand All</span>
                    </button>
                  </div>
                </div>
                <div className="pt-2">
                  {layers.map((layer, i) => (
                    <ShareholderLayer
                      key={i}
                      layerName={layer.name}
                      shareholdersForLayer={layer.shareholders}
                      shareholders={shareholders}
                      collapsed={collapsedLayers[layer.name] ?? false} // controlled
                      onToggle={() =>
                        setCollapsedLayers((prev) => ({
                          ...prev,
                          [layer.name]: !prev[layer.name],
                        }))
                      }
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/cards.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">
                  Connect External Account
                </h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(3);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            {bankdata.map((bank, index) => (
              <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6 border rounded-md">
                {/* Toggle Button on Top Right */}
                <div className="absolute top-2 pb-4 right-4 flex items-center space-x-2">
                  {bank.isDefault && (
                    <div className="font-semibold border-2 border-black text-black text-[12px] px-3 py-1 rounded-full bg-white bg-opacity-20">
                      DEFAULT
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-1 mt-4 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pt-6 pr-6">
                  {/* Column 1 */}
                  <div className="flex flex-col md:px-4 md:pt-6">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-labelColour"
                    >
                      {index + 1}. Account Holder Name
                    </label>
                    <span className="text-sm">{bank.account_name}</span>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Account Number or IBAN
                      </label>
                      <div className="text-sm">{bank.account_number}</div>
                    </div>
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 mt-4 text-xs"
                    >
                      <span className="text-labelColour">Swift Code</span>
                    </label>
                    <div className="text-sm">{bank.swift}</div>
                    <div className="flex flex-row gap-2 mt-2 mb-2">
                      {bank.isVerified && (
                        <>

                          <div className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">

                            <img
                              src="/valid.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Verified

                          </div>

                        </>
                      )}
                      {!bank.isVerified && (
                        <>

                          <div className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">

                            <img
                              src="/danger.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Unverified

                          </div>

                        </>
                      )}
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs text-labelColour"
                    >
                      Branch Identifier{" "}
                    </label>
                    <span className="text-sm">{bank.branch_identifier}</span>
                    {bank.branch_identifier_id == 1 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1  mt-4  text-xs text-labelColour"
                        >
                          BSB
                        </label>
                        <span className="text-sm">{bank.bsb}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 2 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Country{" "}
                        </label>
                        <span className="text-sm">{bank.country}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Financial Institution Identifier{" "}
                        </label>
                        <span className="text-sm">{bank.fin_identifier}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 3 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Routing Number{" "}
                        </label>
                        <span className="text-sm">{bank.rountingNumber}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Payment Method{" "}
                        </label>
                        <span className="text-sm">{bank.paymentMethod}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          ACH Code{" "}
                        </label>
                        <span className="text-sm">{bank.achCode}</span>
                      </>
                    )}
                  </div>

                  {/* Column 3 */}
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-labelColour">Currency</span>
                    </label>
                    <div className="text-sm">{bank.currency.name}</div>
                    {(bank.status == "proof_attached" ||
                      bank.status == "approved" ||
                      bank.status == "rejected") && (
                      <div className="mb-2 mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Uploaded Docs
                        </label>
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div className="flex-col flex">
                            <span className="text-black">test.pdf</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Address
                      </label>
                      <div className="text-sm">
                        {bank.address_line1 != null ? bank.address_line1 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line2 != null ? bank.address_line2 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line3 != null ? bank.address_line3 : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.name}
                fileName={currentDocument.name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex flex-col md:flex-row md:items-center justify-between border-colour-custom px-4 py-2 gap-2">
              {/* Left Section */}
              <div className="flex items-center space-x-2">
                <img src="/money-2.svg" alt="Cash Icon" className="h-6 w-6" />
                <h1 className="text-xl font-medium">
                  Cash Account Information
                </h1>
              </div>

              {/* Right Section - Responsive */}
              <div className="flex items-center justify-start md:justify-end gap-x-2 flex-wrap">
                <div className="flex flex-col items-start md:items-end">
                  <span className="text-sm font-semibold text-[#464646] leading-tight">
                    No. Of Cash Account
                  </span>
                </div>
                <span className="text-md font-semibold hidden md:inline">
                  |
                </span>
                <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                  {String(accounts.length).padStart(2, "0")}
                </span>

                <img
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(4);
                  }}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />

              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {Array.from({ length: accounts.length }).map((_, index) => (
                <div key={index} className="px-4 py-2">
                  <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Account No.{String(index + 1).padStart(2, "0")}
                  </label>
                  <span className="text-sm">{accounts[index].label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">

            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(5);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
 
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">

                {(formData.companycategoryId == 2 ||
                  formData.companycategoryId == 3 ||
                  (formData.companycategoryId == 1 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >

                        A search/extract of the relevant Australian stock
                        exchange
                      </label>
                    </div>
                    {ticketLink != "" && (
                      <>
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Ticket Number
                        </label>
                        <span>{ticketLink}</span>
                      </>
                    )}
                    {fileTicket && (
                      <>
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Uploaded File
                        </label>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(fileTicket);
                          }}
                          className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                        >
                          <div className="flex-col flex">
                            <span className="text-black">
                              {fileTicket.name}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        A public document issued by the company (E.g. Annual
                        General Report)
                      </label>
                    </div>
                    {filePublicDocument && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(filePublicDocument);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {filePublicDocument.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {(formData.companycategoryId == 2 ||
                  (formData.companycategoryId == 1 &&
                    formData.companyTypeId == 1) ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className={`${
                          formData.companycategoryId == 2 ||
                          formData.companycategoryId == 3
                            ? "mt-4 "
                            : ""
                        } text-sm text-labelColour  whitespace-normal break-words block`}
                      >
                        Valid Company Registration Certificate issued by ASIC
                      </label>
                    </div>
                    {fileCompanyRegistration && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileCompanyRegistration);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileCompanyRegistration.name}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className={`mt-4 text-sm text-labelColour  whitespace-normal break-words block`}
                      >
                        Disclosure certificate verifying information about the
                        beneficial ownership of the company{" "}
                      </label>
                    </div>
                    {fileDisclosure && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileDisclosure);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileDisclosure.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="flex items-center justify-between mt-4">
                  <label
                    htmlFor="investmentType"
                    className={`mt-4 text-sm text-labelColour  whitespace-normal break-words block`}
                  >
                    A search/extract of the relevant ASIC database
                  </label>
                </div>
                {fileExtractDocument && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileExtractDocument);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black">
                        {fileExtractDocument.name}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {(formData.companycategoryId == 1 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 1)) && (
                  <>
                    {" "}
                    <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                      <label
                        htmlFor="investmentType"
                        className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center"
                      >
                        Does your company possess a financial services license?
                      </label>
                      <div className="flex items-center gap-4 opacity-50 ">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value="yes"
                            checked={hasLicense === "yes"}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value="no"
                            checked={hasLicense === "no"}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      {hasLicense == "yes" && (
                        <>
                          <label
                            htmlFor="firstName"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            Licence Number
                          </label>
                          <span>{licenseNumber}</span>
                          <div className="flex items-center justify-between mt-4">
                            <label
                              htmlFor="investmentType"
                              className={`mt-4 text-sm text-labelColour  whitespace-normal break-words block`}
                            >
                              Upload a search of the license or other records of
                              the relevant commonwealth, state, or Territory
                              regulator
                            </label>
                          </div>
                          {fileLicense && (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileLicense);
                              }}
                              className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                            >
                              <div className="flex-col flex">
                                <span className="text-black">
                                  {fileLicense.name}
                                </span>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
                {(formData.companycategoryId == 2 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className={`text-sm text-labelColour  whitespace-normal break-words block`}
                      >
                        Valid company registration certificate issued by the
                        relevant foreign registration body
                      </label>
                    </div>
                    {fileForeignRegistration && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileForeignRegistration);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileForeignRegistration.name}
                          </span>
                        </div>
                      </div>
                    )}
                    <label
                      htmlFor="firstName"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Jurisdiction of the primary operations of the company
                    </label>
                    <span>{jurisdiction}</span>
                    <label
                      htmlFor="firstName"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Location of the foreign stock or equivalent exchange
                    </label>
                    <span>
                      {stockexchangeLocation ? stockexchangeLocation.full : ""}
                    </span>
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className={`text-sm text-labelColour  whitespace-normal break-words block`}
                      >
                        Valid Australian financial services license issued by
                        ASIC
                      </label>
                    </div>
                    {fileFinancialService && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileFinancialService);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileFinancialService.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <label
                  htmlFor="investmentType"
                  className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center mt-4"
                >
                  If applicable, description and proof of any current or recent
                  prosecutions and inquiries related to money laundering,
                  terrorist links, tax offenses, and corruption{" "}
                </label>
                <div className="flex items-center gap-4 opacity-50 ">
                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="signatory"
                      value="yes"
                      checked={ifApplicable === "yes"}
                      className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                    />
                    <span className="ml-2">Yes</span>
                  </label>
                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="signatory"
                      value="no"
                      checked={ifApplicable === "no"}
                      className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
                {ifApplicable === "yes" && (
                  <>
                    <div className="mt-4">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Description
                      </label>
                      <span>{description}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Proof
                      </label>
                    </div>
                    {fileProof && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileProof);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">{fileProof.name}</span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="">
                  <label
                    htmlFor="description"
                    className="mb-1 text-sm text-labelColour"
                  >
                    ABN
                  </label>
                  <span>{abn}</span>
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="description"
                    className="mb-1 text-sm text-labelColour"
                  >
                    ABN Status
                  </label>
                  <span>{abnStatus}</span>
                </div>
                {(formData.companycategoryId == 1 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 1)) && (
                  <>
                    {" "}
                    <div className="flex items-center justify-between">
 
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >

                        Contracts with third parties to verify the intended
                        transaction
                      </label>
                    </div>
                    {fileThirdParty && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileThirdParty);
 
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">

                          <span className="text-black">
                            {fileThirdParty.name}
                          </span>
                        </div>
                      </div>
                    )}{" "}
                  </>
                )}
                {(formData.companycategoryId == 2 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Evidence about the activities undertaken by the company
                      </label>
                    </div>
                    {fileActivityEvidence && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileActivityEvidence);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileActivityEvidence.name}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Statement of Advise
                      </label>
                    </div>
                    {fileAdviceStatement && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileAdviceStatement);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileAdviceStatement.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="mt-4">
                  <label
                    htmlFor="description"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Website Link
                  </label>
                  <span>{webLink}</span>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          {/* Save as Draft */}
          <button
            onClick={() => {
              setIsConfirmWithdraw(true);
            }}
            className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Withdraw Application</span>
          </button>

          <button
            onClick={() => {
              setIsConfirmSubmit(true);
            }}
            className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Submit</span>
          </button>
        </div>
      </footer>
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p class="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                  setCurrentStep(1);
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/tick-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Hi John!</h2>
            <h2 class="text-md font-medium mb-2">
              Individual Application Form has been Submitted Successfully{" "}
            </h2>
            <p class="text-sm text-black mb-4">
              Caprock team will evaluate your application and get back to you
              shortly.
            </p>
            <p class="text-sm text-black mb-4">Thank You. </p>
          </div>
        </div>
      )}
    </div>
  );
};

const ShareholderLayer = ({
  layerName,
  shareholdersForLayer = [],
  collapsed = false,
  onToggle,
  shareholders = [],
}) => {
  const isOpen = !collapsed; // fully controlled
  // First layer shareholders
  const [isFormValid, setIsFormValid] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  // Controls state
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Sub-layer shareholders (per tab)
  const [layerData, setLayerData] = useState(() => {
    let initial = {};
    shareholdersForLayer.forEach((s, idx) => {
      initial[idx] = [
        {
          id: s.id,
          name: s.name,
          type: s.type,
          shares: s.shares,
          email: s.email,
          errors: s.errors,
        },
      ];
    });
    return { [layerName]: initial };
  });
  const calculateSharesCounter = (list) => {
    const total = list.reduce((acc, s) => acc + Number(s.shares || 0), 0);
    return `${total.toFixed(2)}`;
  };

  /** ----------------------
   * Root Layer Handlers
   * ---------------------- */
  useEffect(() => {
    setActiveTab(0); // reset tab index when layer data changes
  }, [shareholdersForLayer]);

  useEffect(() => {
    if (!shareholders.length) {
      setIsFormValid(false);
      return;
    }

    const allFilled = shareholders.every(
      (s) =>
        s.name.trim() !== "" &&
        s.type.trim() !== "" &&
        s.email.trim() !== "" &&
        !s.errors?.email &&
        parseFloat(s.shares) > 0
    );

    const totalShares = calculateSharesCounter(shareholders);
    if (allFilled && Number(totalShares) === 100.0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [shareholders]);
  const isLayerFormValid = (tabIdx) => {
    const list = layerData[layerName][tabIdx] || [];
    if (!list.length) return false;

    // All rows filled (and no field errors)
    const allFilled = list.every(
      (s) =>
        s.name.trim() !== "" &&
        s.type.trim() !== "" &&
        s.email.trim() !== "" &&
        !s.errors?.email &&
        parseFloat(s.shares) > 0
    );

    // Shares must equal 100
    const totalShares = calculateSharesCounter(list);

    return allFilled && Number(totalShares).toFixed(2) === "100.00";
  };

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <>
          {/* CASE 1: Root Layer (no tabs) */}
          {shareholdersForLayer.length === 0 && (
            <div className="p-4 border rounded-b-lg">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-[#8C8C8C]">
                  <thead className="">
                    <tr className="border-[#EDEDED] border font-medium">
                      <th className="p-2 text-left font-medium"></th>
                      <th className="p-2 text-left font-medium">
                        Shareholder Name
                      </th>
                      <th className="p-2 text-left font-medium">
                        Type Of Shareholder
                      </th>
                      <th className="p-2 text-left font-medium">Shares</th>
                      <th className="p-2 text-left font-medium">
                        Email Address
                      </th>
                      <th className="p-2 text-left font-medium">
                        User Registration
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {shareholders.map((s, i) => (
                      <tr key={s.id} className="border-t font-medium">
                        <td className="p-2 text-[#8C8C8C]">
                          {String(i + 1).padStart(2, "0")}.
                        </td>
                        <td className="p-2 text-black">
                          <span>{s.name}</span>
                        </td>
                        <td className="p-2 text-black">
                          <span>{s.type}</span>
                        </td>
                        <td className="p-2 text-black">
                          <span>{s.shares}</span>
                        </td>
                        <td className="p-2 text-black">
                          <span>{s.email}</span>
                        </td>
                        <td className="p-2">
                          {s.type !== "Individual" && s.shares >= 25 ? (
                            <div className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium">
                              Fill Application
                            </div>
                          ) : (
                            <span className="text-gray-400">—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* CASE 2: Sub-Layers (with tabs) */}
          {shareholdersForLayer.length > 0 && (
            <div className="">
              {/* Tabs */}
              <div className="flex  border-b">
                {shareholdersForLayer.map((s, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTab(idx)}
                    className={`px-4 py-2 text-sm font-medium ${
                      activeTab === idx
                        ? "bg-black text-white"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {s.name}
                  </button>
                ))}
              </div>
              <div className="p-4 border rounded-b-lg">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-gray-700">
                    <thead className="">
                      <tr className="border-[#EDEDED] border font-medium">
                        <th className="p-2 text-left font-medium"></th>
                        <th className="p-2 text-left font-medium">
                          Shareholder Name
                        </th>
                        <th className="p-2 text-left font-medium">
                          Type Of Shareholder
                        </th>
                        <th className="p-2 text-left font-medium">Shares</th>
                        <th className="p-2 text-left font-medium">
                          Email Address
                        </th>
                        <th className="p-2 text-left font-medium">
                          User Registration
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(layerData?.[layerName]?.[activeTab] || []).map(
                        (s, idx) => (
                          <tr key={s.id} className="border-t font-medium">
                            <td className="p-2 text-[#8C8C8C]">
                              {String(idx + 1).padStart(2, "0")}.
                            </td>
                            <td className="p-2 text-black">
                              <span>{s.name}</span>
                            </td>
                            <td className="p-2 text-black">
                              <span>{s.type}</span>
                            </td>
                            <td className="p-2 text-black">
                              <span>{s.shares}</span>
                            </td>
                            <td className="p-2 text-black">
                              <span>{s.email}</span>
                            </td>
                            <td className="p-2">
                              {s.type !== "Individual" && s.shares >= 25 ? (
                                <button className="px-3 py-1 rounded-lg shadow-md border text-black font-medium">
                                  Fill Application
                                </button>
                              ) : (
                                <span className="text-gray-400">—</span>
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}; 
export default ReviewSubmitCorporate;
